import { Usuario } from './usuario';

export class Aplicativo {
    usuario: Usuario;
    tokenAcesso: string;
    tokenExpirationDate: Date;
}